module.exports = __webpack_public_path__ + "img/btn-descarga.d9538d0a.png";